import { FeaturePanel, Section } from '@ahmdigital/ui';
import React from 'react';

import chickenDinnerData from './data';
import styles from './styles.module.sass';

const { tiles } = chickenDinnerData;

const ChickenDinnerSection = () => (
  <Section variant={['paddingTopSpacer2', styles.section]}>
    <FeaturePanel tiles={tiles} title="" />
  </Section>
);

export default ChickenDinnerSection;
